module.exports = __webpack_public_path__ + "img/bg-screen.ef5a752a.png";